import styled, { css, DefaultTheme, FlattenInterpolation, ThemeProps } from 'styled-components';
import { body1, header6 } from '@westwing/ui-kit/typography';

type TextVariant = 'paragraph' | 'subtitle';

export const paragraphStyles = css`
    ${body1}
    color: ${({ theme }) => theme.colors.charcoal100};
    margin-top: 0;
`;

export const subtitleStyles = css`
    ${header6}
    color: ${({ theme }) => theme.colors.charcoal100};
    line-height: 1.6;
    margin-top: 0;
`;

const variantOptions: Record<TextVariant, FlattenInterpolation<ThemeProps<DefaultTheme>>> = {
    paragraph: paragraphStyles,
    subtitle: subtitleStyles,
};

const Text = styled.p<{
    variant?: TextVariant;
    style?: React.CSSProperties & { '--text-align'?: 'center' | 'left' };
}>`
    ${({ variant = 'paragraph' }) => variantOptions[variant]}

    color: ${({ theme }) => theme.colors.charcoal100};
    text-align: var(--text-align, inherit);
    margin: 0;
`;

export default Text;
